<template>
    <div class="company-create mb-3 mt-page">

        <data-form
                   :title="$i18n.gt('HEADING_ADD_COMPANY')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="companyFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_COMPANY_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_COMPANY')"
                   :submit-success-route="resellerId ? `/company/resellerAdmin/${resellerId}` : `/company/admin`"
                   :cancel-route="resellerId ? `/company/resellerAdmin/${resellerId}` : `/company/admin`">
        </data-form>

    </div>
</template>

<script>

    import Vue from 'vue'
    import * as _ from 'lodash'
    import CompanyFields from '../models/Company'

    /**
     * Page for admin to create a Company
     */
    export default Vue.extend({
        name: 'CompanyCreate',
        props: {
            resellerId: {
                default: null,
                required: false,
                type: Number
            }
        },
        data () {
            return {
                companyFields: CompanyFields,
                fieldGroups: [
                    ['name', 'contact_name', 'contact_email'],
                ]
            }
        },
        methods: {
            loadModelInstance () {
                return new Promise((resolve, reject) => {
                    const company = {}
                    resolve(company)
                })
            },
            onSubmit (modelInstance) {
                if (this.resellerId) {
                    modelInstance.reseller_id = this.resellerId
                }
                return this.$api.createItem(this, 'company', modelInstance)
            },
        }
    })

</script>
